import debounce from "lodash.debounce";
import { forwardRef, memo, useCallback, useEffect, useState } from "react";

const InputSearch = memo(
  forwardRef(({ searchValue, setSearchValue, setPageNumber }, ref = null) => {
    const [keyWord, setKeyWord] = useState("");

    const handleSearchChange = (event) => {
      const value = event.target.value;
      setKeyWord(value);
      debouncedSearchTermCallback(value);
    };

    const debouncedSearchTermCallback = useCallback(
      debounce((value) => {
        setSearchValue(value);
        setPageNumber(1);
      }, 600),
      []
    );

    return (
      <div className="relative">
        <label htmlFor="search" className="text-white">
          البحث
        </label>
        <input
          ref={ref}
          id="search"
          type="search"
          className={`block px-4 py-2 text-white bg-green-500/20 border border-mainLight h-9
         rounded-md  focus:outline-none w-full
          disabled:bg-gray-200 transition-width duration-200 peer`}
          value={keyWord}
          placeholder="البحث"
          autoComplete="off"
          onChange={handleSearchChange}
        />
      </div>
    );
  })
);

const SelectInput = ({ value, setValue, options, setPageNumber }) => {
  return (
    <div className="relative">
      <label htmlFor="status" className="text-white">
        الحالة
      </label>
      <select
        id="status"
        className={`block px-4 text-white bg-green-500/20 border border-mainLight h-9
         rounded-md  focus:outline-none w-full
          disabled:bg-gray-200 transition-width duration-200 peer`}
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
          setPageNumber(1);
        }}
      >
        <option value="" className="bg-mainLight">
          حدد الحالة
        </option>
        {options.map((opt) => (
          <option key={opt.value} className="bg-mainLight" value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};

const DateInput = memo(({ title, value, setValue, setPageNumber }) => {
  const [keyWord, setKeyWord] = useState("");

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setKeyWord(value);
    debouncedSearchTermCallback(value);
  };

  const debouncedSearchTermCallback = useCallback(
    debounce((value) => {
      setValue(value);
      setPageNumber(1);
    }, 600),
    []
  );

  useEffect(() => {
    console.log(value);
  }, [value]);

  return (
    <div className="relative">
      <label className="text-white">{title}</label>
      <input
        type="date"
        className={`block px-4 py-2 text-white bg-green-500/20 border border-mainLight h-9
         rounded-md  focus:outline-none w-full
          disabled:bg-gray-200 transition-width duration-200 peer`}
        value={keyWord}
        onChange={handleSearchChange}
      />
    </div>
  );
});

export default InputSearch;
export { DateInput, SelectInput };
